<template>
  <v-app>
    <div class="main-viewport">
      <template v-if="ready">
        <v-app-bar app color="dark" flat key="app-bar">
          <v-toolbar-title class="pl-1">
            <v-img src="~@/assets/logo_long_white.png" alt="AirSage Logo" width="158" contain />
          </v-toolbar-title>
        </v-app-bar>
        <v-main key="app-content">
          <demo />
        </v-main>
        <v-snackbar v-model="snackbar" :color="alert.color" :timeout="alert.timeout" key="app-snackbar">
          <span>{{ alert.message }}</span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">Close</v-btn>
          </template>
        </v-snackbar>
      </template>
      <template v-else>
        <v-container dark fluid fill-height key="app-loading">
          <v-row justify="center" fill-height>
            <v-progress-circular color="primary" size="64" indeterminate />
          </v-row>
        </v-container>
      </template>
    </div>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import alert from '@/mixins/alert';
import Demo from '@/components/Demo';

export default {
  name: 'JacquerieDemo',

  mixins: [alert],

  components: {
    Demo
  },

  data() {
    return {
      snackbar: false
    };
  },

  computed: {
    ...mapState(['alert', 'ready']),
    ...mapGetters(['userId', 'userName', 'isAdmin'])
  },

  async created() {
    try {
      await this.$auth.renewTokens();
    } catch (error) {
      this.$auth.login();
    }
  },

  watch: {
    alert: {
      deep: true,
      handler() {
        if (this.alert.color && this.alert.message && this.alert.message.length > 0) {
          this.snackbar = true;
        }
      }
    }
  },

  methods: {
    async handleLoginEvent(data) {
      try {
        await this.setUser(data.profile);
      } catch (error) {
        this.alertError(error);
      } finally {
        this.setReady(true);
      }
    },

    logout() {
      this.$auth.logOut();
    },

    ...mapActions(['setUser', 'setReady'])
  }
};
</script>

<style lang="scss">
.main-viewport {
  height: 100%;
}

.v-main {
  background: #FFFFFF;
}
</style>
